export default {
    3:'fetchChat',
    2:'fetchContribution'
}


